<script>
import { mapState, mapActions } from "vuex";

export default {
  props: ["title"],
  computed: {
    ...mapState("newPurchase", ["professional_id", "professionals"])
  },

  methods: {
    ...mapActions("newPurchase", ["setProfessionalId"])
  }
};
</script>

<template>
  <div id="professionals" class="section">
    <div class="section-title">
      {{title}}
      <hr>
    </div>

    <div class="section-body">
      <div
        v-for="professional in professionals"
        :key="professional.id"
        class="professional"
        :class="{'checked': professional_id == professional.id}"
        @click="setProfessionalId(professional.id); $emit('scrollTo', '#informations')"
      >
        <img src="../../../../static/user-default.svg">
        <div class="hovered">
          <div class="icon-check"></div>
        </div>
        <p>{{professional.name}}</p>
        <small>{{professional.clears_count}} limpezas</small>
        <img src="../../../../static/stars.svg">
      </div>
    </div>
  </div>
</template>

<style scoped>
.section-body {
  display: flex;
  flex-direction: row;
}

.professional {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  user-select: none;
  cursor: pointer;
}

.professional:first-child {
  margin-left: 0;
}

.professional:last-child {
  margin-right: 0;
}

.professional p {
  margin: 10px 0 5px 0;
}

.professional small {
  font-size: 12px;
}

.professional img:first-child {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 4px solid #f1f1f1f1;
  border-radius: 100%;
}

.professional .hovered {
  opacity: 0;
  width: 120px;
  height: 120px;
  margin-top: -124px;
  border-radius: 100%;
  background: linear-gradient(
    45deg,
    rgba(204, 204, 204, 0.8) 0%,
    rgba(204, 204, 204, 0.3) 100%
  );
  z-index: 99;
  transition: all 0.25s ease;
}

.professional .hovered .icon-check {
  background: url("../../../../static/icon-check.svg") no-repeat center;
  background-size: 25px;
  width: 100%;
  height: 100%;
}

.professional.checked .hovered {
  opacity: 1;
  background: linear-gradient(
    45deg,
    rgba(96, 50, 133, 0.8) 0%,
    rgba(175, 0, 107, 0.8) 100%
  );
}

.professional:hover .hovered {
  opacity: 1;
}

.professional img:last-child {
  height: 12px;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Professionals.vue